/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FormatClearIcon
 */
export default class FormatClearIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.784 8.892l4.243 4.242a1 1 0 010 1.414l-8.014 8.014a1 1 0 01-1.415 0L9.356 18.32a1 1 0 010-1.415l8.014-8.013a1 1 0 011.414 0zM14.55 14.54l-3.073 3.072 2.829 2.829 3.067-3.067-2.823-2.834zM8.908 2.58l4.034 8.74-1.68 1.68H4.486l-1.578 3.42a1 1 0 01-1.816-.84l6-13a1 1 0 011.816 0zM8 5.387L5.41 11h5.181l-2.59-5.614z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

